
function doFunction() {

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-carica-letture-file',
      title: 'Caricamento Letture GAS',
      data: {type:'gas'},
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': doFunction,
}
